import { useEffect, useRef } from 'react'
import { authStore } from '~/stores'
import { utmTrackingStore } from '~/features/utm-tracking/utm-tracking.store'

export const useUtmTracking = (location) => {
	const hasTracked = useRef(false)

	const hasUtmParams = (search) => {
		if (!search) return false

		const params = new URLSearchParams(search)
		const utmFields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content']

		// Check if at least one UTM param has non-empty value
		return utmFields.some((field) => {
			const value = params.get(field)
			return value && value.trim() !== ''
		})
	}

	useEffect(() => {
		if (hasTracked.current) return

		if (location?.search && hasUtmParams(location.search)) {
			const fullUrl = window.location.href

			if (!authStore.isAnonymous) {
				utmTrackingStore.trackUtm(fullUrl)
				hasTracked.current = true
			} else {
				utmTrackingStore.setUtmParams(fullUrl)
			}
		} else if (!authStore.isAnonymous) {
			const storedUrl = utmTrackingStore.getStoredUtmData()
			if (storedUrl) {
				utmTrackingStore.trackUtm(storedUrl)
				hasTracked.current = true
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location?.search, authStore.isAnonymous])
}
